module.exports = __webpack_public_path__ + "static/media/animal-penguin.c4aa1995.png";